<template>
    <div>

        <component v-if="Object.keys($i18n).length > 0" v-show="layout" :is="layout"></component>

        <theme></theme>
        <loader></loader>
    </div>
</template>

<script type="text/javascript">
    import outside from './layout/layout-outside.vue';
    import theme from './theme.vue';
    import loader from './loader.vue';
    import report from './utils/report.vue';

    export default {
        name: 'root',

        components: {
            'inside': function (resolve) {
                require(['./layout/layout-inside.vue'], resolve);
            },
            outside,
            theme,
            loader,
            report,
        },

        computed: {
            layout: function() {
                if (typeof this.$route.meta.guest === 'undefined' || !this.$route.meta.guest) {
                    // dont show inside layout unless we have a user

                    if (typeof this.$store.state.user.id === 'undefined') {
                        return null;
                    }

                    return 'inside';
                }

                return 'outside';
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/root.vue